/**
 * Which sample set the GUIDE line plays on, per exercise.
 *
 * Anthony, 2026-09-07: "apply the clarinet to any exercises that have to
 * slide or anything that the piano sounds cannot recreate. Otherwise, leave
 * it at piano for everything else." Two things a struck piano cannot do:
 * bend (a glide is a pitch ramp across the note, which on a decaying piano
 * is a dying note sliding) and hold (by the fourth beat a piano sample is a
 * whisper, so a crescendo or a long sustain has nothing left to shape).
 *
 * So: any glide, or any pitched note of SUSTAIN_BEATS or more → the
 * sustained set ('voice' — today the clarinet). Everything else → 'piano'.
 * Unpitched patterns (hiss, clicks) are ticks and never reach a sample.
 * The engine's Auto setting calls this per exercise; Clarinet / Piano on the
 * mix row override it for the session.
 */
export const SUSTAIN_BEATS = 4;

const isPitched = (tok) => !(tok === 'X' || tok === 'R' || tok === 'H');

export const needsSustainedGuide = (exercise) => {
	if (!exercise || !Array.isArray(exercise.pattern)) return false;
	if (Array.isArray(exercise.glides) && exercise.glides.length > 0) return true;
	return exercise.pattern.some((n) => isPitched(n[0]) && Number(n[1] || 0) >= SUSTAIN_BEATS);
};

/** 'voice' (the sustained set) or 'piano'. */
export const guideInstrumentFor = (exercise) => (needsSustainedGuide(exercise) ? 'voice' : 'piano');
